// "All" is active by default. Picking categories narrows the list to posts in any
// of them, laid out in an even grid; deselecting the last category (or picking "All") shows everything again.
export function initBlogPostsFilter(block) {
	const pills = [...block.querySelectorAll('.blog-posts__filter')];
	const items = [...block.querySelectorAll('.blog-posts__item')];
	if (!pills.length || !items.length) return false;

	const allPill = pills.find((pill) => !pill.dataset.category);
	const selected = new Set();

	const update = () => {
		allPill.setAttribute('aria-pressed', String(!selected.size));
		pills.forEach((pill) => {
			if (pill !== allPill) pill.setAttribute('aria-pressed', String(selected.has(pill.dataset.category)));
		});

		items.forEach((item, index) => {
			const categories = item.dataset.categories.split(' ');
			const visible = !selected.size || categories.some((slug) => selected.has(slug));

			item.hidden = !visible;
			// Filtered results use a plain 3-column grid; only the unfiltered list features the newest post.
			item.classList.toggle('blog-posts__item--featured', !selected.size && index === 0);
		});
	};

	pills.forEach((pill) => {
		pill.addEventListener('click', () => {
			const {category} = pill.dataset;

			if (!category) selected.clear();
			else if (selected.has(category)) selected.delete(category);
			else selected.add(category);

			update();
		});
	});

	return true;
}

export default function blogPostsBlock(options = {}) {
	try {
		const {block} = options;

		if (!block || block.dataset.blogPostsReady === 'true') return;
		if (!initBlogPostsFilter(block)) return;

		block.dataset.blogPostsReady = 'true';
	} catch (error) {
		console.error(error);
	}
}
